(function () {
  let lastAddButton = null;
  let suppressSuccessUntil = 0;
  let checkoutNudgeTimer = null;

  // --- checkout reminder cycle state ---
  const NUDGE_VISIBLE_MS = 5000; // how long the "checkout here" bubble stays on screen
  const NUDGE_REPEAT_MS = 25000; // wait after the bubble disappears before showing it again
  const NUDGE_REPEAT_AFTER_ADD_MS = 20000; // same, but used once the visitor has added more than one product
  let nudgeRepeatDelay = NUDGE_REPEAT_MS;
  let hasAddedBefore = false;
  let drawerOpenedSinceNudge = false;
  let drawerListenerWired = false;

  function getOverlay() {
    return document.getElementById('granny-cart-celebration');
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function wireDrawerListeners() {
    if (drawerListenerWired) return;

    const drawer = getCartDrawer();
    if (!drawer) return;

    drawerListenerWired = true;

    drawer.addEventListener('dialog:open', function () {
      drawerOpenedSinceNudge = true;
      clearTimeout(checkoutNudgeTimer);
      document.querySelectorAll('.granny-checkout-nudge').forEach((el) => el.remove());
    });
  }

  function isCartOrCheckoutPage() {
    return (
      window.location.pathname.includes('/cart') ||
      window.location.pathname.includes('/checkout')
    );
  }


  function isGeorgianPage() {
    return document.documentElement.lang && document.documentElement.lang.startsWith('ka');
  }

  function getMessage(type) {
    const isGeorgian = isGeorgianPage();

    const messages = {
      success: isGeorgian
        ? "ვაუ??<br>მართლა ჩემი გაკეთებული რაღაცის ყიდვა გინდა??"
        : "wow thanks!!<br>I can't believe u want to buy something I madeeee!!",

      already: isGeorgian
        ? "უკვე კალათაში გაქვს."
        : "already in the cart, bestie!!<br>Granny remembers.",

      emotionalSupport: isGeorgian
        ? "არა შენ მე გამამდიდრებ, რა!<br>უკან დაგბრუნებოდეს."
        : "...you're collecting emotional support objects, aren't you?",

      therapy: isGeorgian
        ? "ისე... თერაპია უფრო ძვირია."
        : "well... therapy is more expensive."
    };

    return messages[type] || messages.success;
  }

  async function chooseSuccessMessageType() {
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());

      if (cart.total_price >= 10000 && Math.random() < 0.2) {
        return 'therapy';
      }

      if (cart.items && cart.items.length >= 2 && Math.random() < 0.3) {
        return 'emotionalSupport';
      }
    } catch (error) {
      console.warn('Granny message cart check failed:', error);
    }

    return 'success';
  }

  function makeParticle(src, x, y, options = {}) {
    const overlay = getOverlay();
    if (!overlay || !src) return;

    const el = document.createElement('img');
    el.src = src;
    el.alt = '';
    el.decoding = 'async';

    const size = options.size || 24;
    const dx = options.dx || 0;
    const dy = options.dy || -100;
    const delay = options.delay || 0;
    const duration = options.duration || 900;

    Object.assign(el.style, {
      position: 'fixed',
      left: `${x}px`,
      top: `${y}px`,
      width: `${size}px`,
      height: `${size}px`,
      pointerEvents: 'none',
      zIndex: '10000',
      transform: 'translate(-50%, -50%) scale(0.6)',
      opacity: '0',
      imageRendering: 'pixelated'
    });

    overlay.appendChild(el);

    const animation = el.animate(
      [
        { transform: 'translate(-50%, -40%) scale(0.5)', opacity: 0 },
        { transform: 'translate(-50%, -50%) scale(1)', opacity: 1, offset: 0.2 },
        {
          transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(1.15)`,
          opacity: 0
        }
      ],
      { duration, delay, easing: 'ease-out', fill: 'forwards' }
    );

    animation.onfinish = () => el.remove();
  }

  function makeCheckmark(button) {
    const overlay = getOverlay();
    if (!overlay || !button) return;

    const rect = button.getBoundingClientRect();
    const check = document.createElement('div');

    check.textContent = '✓';
    check.setAttribute('aria-hidden', 'true');

    Object.assign(check.style, {
      position: 'fixed',
      left: `${rect.left + rect.width / 2}px`,
      top: `${rect.top + rect.height / 2}px`,
      width: '42px',
      height: '42px',
      borderRadius: '50%',
      background: '#fffaf1',
      border: '3px solid #ef5aa8',
      color: '#ef5aa8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '28px',
      fontWeight: '900',
      lineHeight: '1',
      zIndex: '10002',
      pointerEvents: 'none',
      boxShadow: '0 4px 0 #8f6be8',
      transform: 'translate(-50%, -50%) scale(0.4)',
      opacity: '0'
    });

    overlay.appendChild(check);

    const animation = check.animate(
      [
        { opacity: 0, transform: 'translate(-50%, -50%) scale(0.4) rotate(-10deg)' },
        { opacity: 1, transform: 'translate(-50%, -50%) scale(1.15) rotate(4deg)', offset: 0.22 },
        { opacity: 1, transform: 'translate(-50%, -58%) scale(1) rotate(0deg)', offset: 0.72 },
        { opacity: 0, transform: 'translate(-50%, -90%) scale(0.8) rotate(8deg)' }
      ],
      {
        duration: 1200,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );

    animation.onfinish = () => check.remove();
  }

  function makeMessage(button, type = 'success') {
    if (type === 'success' && Date.now() < suppressSuccessUntil) return;

    if (type === 'already') {
      suppressSuccessUntil = Date.now() + 1800;
      document.querySelectorAll('.granny-cart-wow-message').forEach((el) => el.remove());
    }

    const overlay = getOverlay();
    if (!overlay || !button) return;

    const rect = button.getBoundingClientRect();
    const isFloatingCart = button.classList.contains('granny-mobile-sticky-cart');

    const msg = document.createElement('div');
    msg.className = 'granny-cart-wow-message';
    msg.innerHTML = getMessage(type);

    Object.assign(msg.style, {
      position: 'fixed',
      left: isFloatingCart ? `${rect.right + 18}px` : `${rect.left + rect.width / 2}px`,
      top: isFloatingCart ? `${rect.top + rect.height / 2}px` : `${rect.top - 10}px`,
      transform: isFloatingCart ? 'translate(0, -50%) scale(0.8)' : 'translate(-50%, -100%) scale(0.8)',
      zIndex: '10001',
      pointerEvents: 'none',
      background: '#fffaf1',
      border: '2px solid #ef5aa8',
      borderRadius: '14px',
      padding: '10px 14px',
      color: '#ef5aa8',
      fontSize: '12px',
      lineHeight: '1.35',
      textAlign: 'center',
      maxWidth: '240px',
      boxShadow: '0 6px 0 #8f6be8',
      opacity: '0'
    });

    overlay.appendChild(msg);

    const startTransform = isFloatingCart
      ? 'translate(0, -50%) scale(0.75)'
      : 'translate(-50%, -80%) scale(0.75)';

    const midTransform = isFloatingCart
      ? 'translate(0, -50%) scale(1.05)'
      : 'translate(-50%, -115%) scale(1.05)';

    const holdTransform = isFloatingCart
      ? 'translate(0, -50%) scale(1)'
      : 'translate(-50%, -130%) scale(1)';

    const endTransform = isFloatingCart
      ? 'translate(0, -50%) scale(0.9)'
      : 'translate(-50%, -150%) scale(0.9)';

    const animation = msg.animate(
      [
        { opacity: 0, transform: startTransform },
        { opacity: 1, transform: midTransform, offset: 0.18 },
        { opacity: 1, transform: holdTransform, offset: 0.78 },
        { opacity: 0, transform: endTransform }
      ],
      {
        duration: type === 'already' ? 2300 : 2800,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );

    animation.onfinish = () => msg.remove();
  }

  async function showCheckoutNudge() {
    document.querySelectorAll('.granny-checkout-nudge').forEach((el) => el.remove());

    if (drawerOpenedSinceNudge || isCartOrCheckoutPage()) return;

    try {
      const cart = await fetch('/cart.js').then((res) => res.json());
      if (!cart || cart.item_count < 1) return;
    } catch (error) {
      return;
    }

    const isGeorgian = isGeorgianPage();

    const cartTarget =
      document.querySelector('[data-testid="cart-drawer-trigger"]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[href*="/cart"]');

    if (!cartTarget) return;

    const rect = cartTarget.getBoundingClientRect();

    const nudge = document.createElement('div');
    nudge.className = 'granny-checkout-nudge';
    nudge.innerHTML = isGeorgian
      ? 'ყიდვა აქედან შეგიძლია ↑'
      : 'checkout here ↑';

    Object.assign(nudge.style, {
      position: 'fixed',
      left: `${rect.left + rect.width / 2}px`,
      top: `${rect.bottom + 12}px`,
      transform: 'translate(-50%, -4px) scale(0.9)',
      zIndex: '10005',
      background: '#fffaf1',
      border: '2px solid #ef5aa8',
      borderRadius: '999px',
      padding: '8px 12px',
      color: '#ef5aa8',
      fontSize: '12px',
      fontWeight: '900',
      lineHeight: '1.2',
      fontFamily: 'var(--gt-font-pixel, monospace)',
      boxShadow: '0 5px 0 #8f6be8',
      pointerEvents: 'none',
      opacity: '0',
      whiteSpace: 'nowrap'
    });

    document.body.appendChild(nudge);

    const animation = nudge.animate(
      [
        { opacity: 0, transform: 'translate(-50%, -4px) scale(0.9)' },
        { opacity: 1, transform: 'translate(-50%, 4px) scale(1)', offset: 0.15 },
        { opacity: 1, transform: 'translate(-50%, 4px) scale(1)', offset: 0.85 },
        { opacity: 0, transform: 'translate(-50%, -2px) scale(0.95)' }
      ],
      {
        duration: 5000,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );

    animation.onfinish = () => nudge.remove();

    cartTarget.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.12)', offset: 0.4 },
        { transform: 'scale(1)' }
      ],
      {
        duration: 450,
        easing: 'ease-out'
      }
    );
  }

  function armNudgeCycle(delay) {
    clearTimeout(checkoutNudgeTimer);

    checkoutNudgeTimer = setTimeout(async () => {
      if (drawerOpenedSinceNudge || isCartOrCheckoutPage()) return;

      try {
        const cart = await fetch('/cart.js').then((res) => res.json());
        if (!cart || cart.item_count < 1) return;
      } catch (error) {
        return;
      }

      await triggerNudgeCycle();
    }, delay);
  }

  async function triggerNudgeCycle() {
    await showCheckoutNudge();
    armNudgeCycle(NUDGE_VISIBLE_MS + nudgeRepeatDelay);
  }

  window.launchCelebration = async function (button) {
    const overlay = getOverlay();
    const assets = window.GrannyThemeAssets || {};

    if (!overlay || !button) return;
    if (!assets.heartStar || !assets.sparkle) return;

    const rect = button.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    const particles = [
      { src: assets.heartStar, size: 30, dx: -34, dy: -120, delay: 0, duration: 950 },
      { src: assets.heartStar, size: 24, dx: 30, dy: -105, delay: 60, duration: 900 },
      { src: assets.heartStar, size: 20, dx: 0, dy: -145, delay: 120, duration: 1000 },
      { src: assets.sparkle, size: 18, dx: -60, dy: -80, delay: 20, duration: 780 },
      { src: assets.sparkle, size: 16, dx: 56, dy: -76, delay: 90, duration: 820 },
      { src: assets.sparkle, size: 14, dx: -8, dy: -150, delay: 150, duration: 900 }
    ];

    particles.forEach((particle) => {
      makeParticle(
        particle.src,
        x + (Math.random() * 8 - 4),
        y + (Math.random() * 8 - 4),
        particle
      );
    });

    makeCheckmark(button);

    const messageType = await chooseSuccessMessageType();
    makeMessage(button, messageType);

    wireDrawerListeners();
    drawerOpenedSinceNudge = false;
    nudgeRepeatDelay = hasAddedBefore ? NUDGE_REPEAT_AFTER_ADD_MS : NUDGE_REPEAT_MS;
    hasAddedBefore = true;
    await triggerNudgeCycle();
  };

  window.launchAlreadyInCartMessage = function (button) {
    if (!button) return;
    makeMessage(button, 'already');
  };

  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      'button.granny-product-atc, button.granny-tab-atc-clone, .granny-mobile-sticky-cart, .quick-add [name="add"], .quick-add button, product-card [name="add"], .card [name="add"]'
    );

    if (!button) return;

    lastAddButton = button;
  });

  if (!window.__grannyCelebrationFetchWrapped) {
    window.__grannyCelebrationFetchWrapped = true;

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      try {
        const input = args[0];
        const init = args[1] || {};

        const url =
          typeof input === 'string'
            ? input
            : input && typeof input.url === 'string'
              ? input.url
              : '';

        const method = String(
          init.method ||
          (input && input.method) ||
          'GET'
        ).toUpperCase();

        const isCartAdd =
          method === 'POST' &&
          url.includes('/cart/add');

        if (lastAddButton && isCartAdd) {
          const buttonToAnimate = lastAddButton;
          lastAddButton = null;

          if (response.ok) {
            setTimeout(() => {
              window.launchCelebration?.(buttonToAnimate);
            }, 80);
          } else {
            setTimeout(() => {
              window.launchAlreadyInCartMessage?.(buttonToAnimate);
            }, 80);
          }
        }
      } catch (error) {
        console.warn('Cart celebration check failed:', error);
      }

      return response;
    };
  }
})();